import Vue from "vue";
import Router from "vue-router";
import Index from "./pages/Index";
import Svetlana from "./pages/Svetlana";
import Maria from "./pages/Maria";
import Elena from "./pages/Elena";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: Index
    },
    {
      path: "/svetlana",
      name: "svetlana",
      component: Svetlana
    },
    {
      path: "/elena",
      name: "elena",
      component: Elena
    },
    {
      path: "/maria",
      name: "maria",
      component: Maria
    }
  ]
});
router.beforeEach(function(to, from, next) {
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 1);
  next();
});
import VueYandexMetrika from "vue-yandex-metrika";
import VueAnalytics from "vue-analytics";
Vue.use(VueYandexMetrika, {
  id: 41254644,
  router: router,
  env: process.env.NODE_ENV
});

Vue.use(VueAnalytics, {
  id: "UA-88014128-26",
  router
  // debug: {
  //   enabled: true,
  //   trace: false,
  //   sendHitTask: true
  //
  // }
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js